import { useEffect, useState } from "react";
import api from "@/lib/api";

let cached = null; // { ticket, expiresAt }
let inflight = null;

/** Short-lived read-only ticket for <audio>/<video>/download URLs (never the session token). */
export async function getMediaTicket() {
  if (cached && cached.expiresAt - Date.now() > 5 * 60 * 1000) return cached.ticket;
  if (!inflight) {
    inflight = api.post("/auth/media-ticket").then((r) => {
      cached = { ticket: r.data.ticket, expiresAt: new Date(r.data.expires_at).getTime() };
      return cached.ticket;
    }).finally(() => { inflight = null; });
  }
  return inflight;
}

export function mediaUrl(path, ticket) {
  return ticket ? `${path}${path.includes("?") ? "&" : "?"}mt=${encodeURIComponent(ticket)}` : null;
}

/** Resolves to the ticket string (null until loaded); refreshes shortly before expiry. */
export function useMediaTicket() {
  const [ticket, setTicket] = useState(cached?.ticket || null);
  useEffect(() => {
    let alive = true;
    const load = () => getMediaTicket().then((t) => { if (alive) setTicket(t); }).catch(() => {});
    load();
    const id = setInterval(load, 30 * 60 * 1000);
    return () => { alive = false; clearInterval(id); };
  }, []);
  return ticket;
}
